<template>
</template>

<script>
    import Element from '../../modeling/ModelElement'

    export default {
        mixins: [Element],
        name: 'uml-class-element',
        props: {},
        computed: {
        },
        data: function () {
            return {
                isMovedElement: false,
            };
        },
        watch: {
        },
        created: function () {
            var me = this
            me.canvasbase = me.getComponent('uml-class-model-canvas')

            Object.values(me.canvasbase.value.elements).forEach((element) => {
                if (element && me.value.elementView && element._type.includes("ClassGroup")) {
                    var outer = {
                        x: element.elementView.x - element.elementView.width / 2,
                        y: element.elementView.y - element.elementView.height / 2,
                        width: element.elementView.width,
                        height: element.elementView.height
                    }
                    var inner = {
                        x: me.value.elementView.x - me.value.elementView.width / 2,
                        y: me.value.elementView.y - me.value.elementView.height / 2,
                        width: me.value.elementView.width,
                        height: me.value.elementView.height
                    }

                    if (me.canvasbase._isAttached(outer, inner)) {
                        me.value.groupElement = element.elementView.id
                    }
                }
            })
        },
        mounted: function () {
            var me = this;

            me.$EventBus.$on('isMovedElement', function (id) {
                if (me.value.elementView) {
                    //only Element
                    if (me.value.elementView.id == id) {
                        me.isMovedElement = true
                        me.movedNewActivity()
                    } else {
                        if (me.isMovedElement == true) {
                            me.isMovedElement = false
                            me.movedOldActivity()
                        }
                    }
                }
            })

            me.refresh();
        },
        methods: {
            closePanel() {
                if(!this.propertyPanel) this.propertyPanel = true
                this.propertyPanel = false
                if(this.value._type.endsWith('Class'))
                    this.refresh()
            },
            onMoveShape: function () {
                this.$EventBus.$emit('isMovedElement', this.value.elementView.id)
            },
            movedNewActivity() {
                var me = this
                if (me.canvasbase.isLogin && me.canvasbase.isServerModeling && !me.canvasbase.isClazzModeling && !me.isReadOnly) {
                    var obj = {
                        action: 'userMovedOn',
                        editUid: me.userInfo.uid,
                        name: me.userInfo.name,
                        picture: me.userInfo.profile,
                        timeStamp: Date.now(),
                        // editElement: me.value.elementView.id
                        editElement: me.value.elementView ? me.value.elementView.id : me.value.relationView.id
                    }
                    me.pushObject(`db://definitions/${me.params.projectId}/queue`, obj)
                }
            },
            movedOldActivity() {
                var me = this
                if (me.canvasbase.isLogin && me.canvasbase.isServerModeling && !me.canvasbase.isClazzModeling && !me.isReadOnly) {
                    var obj = {
                        action: 'userMovedOff',
                        editUid: me.userInfo.uid,
                        name: me.userInfo.name,
                        picture: me.userInfo.profile,
                        timeStamp: Date.now(),
                        // editElement: me.value.elementView.id
                        editElement: me.value.elementView ? me.value.elementView.id : me.value.relationView.id
                    }
                    me.pushObject(`db://definitions/${me.params.projectId}/queue`, obj)
                }
            },
            onRemoveShape(model) {
                var me = this
                var id = me.value.elementView ? me.value.elementView.id : me.value.relationView.id
                var location = me.value.elementView ? model.$parent.canvasbase.value.elements : model.$parent.canvasbase.value.relations

                if (location && id) {
                    location[id] = null
                }
                
                if (me.value.relationView) {
                    var obj = {
                        action: 'delete',
                        element: me.value
                    }
                    me.$EventBus.$emit(`${me.value.relationView.id}`, obj)
                }

                try {
                    if (me.isCustomMoveExist
                        && me.canvasbase.isServerModeling
                        && !me.canvasbase.isClazzModeling
                        && me.isQueueModeling) {
                        if (me.value) {
                            // me.STATUS_COMPLETE = false
                            // me.canvasbase.value.elements[me.value.elementView.id] = null;

                            var action = me.value.elementView ? 'elementDelete' : 'relationDelete'
                            var obj = {
                                action: action,
                                editUid: me.getEditUid,
                                timeStamp: Date.now(),
                                item: JSON.stringify(me.value)
                            }
                            if (me.params.projectId)
                                me.pushObject(`db://definitions/${me.params.projectId}/queue`, obj)
                        }
                    } else {
                        console.log('local:onRemoveShape, kubernetes')
                        var id = me.value.elementView ? me.value.elementView.id : me.value.relationView.id
                        var location = me.value.elementView ? model.$parent.canvasbase.value.elements : model.$parent.canvasbase.value.relations

                        if (location && id)
                            location[id] = null

                        if(me.initLoad){
                            me.changedTemplateCode = true
                        }

                    }
                    me.validate()
                } catch (e) {
                    alert('Error-onRemove: ', e)
                }
            },
            getComponent(componentName) {
                let component = null
                let parent = this.$parent
                while (parent && !component) {
                    if (parent.$options.name === componentName) {
                        component = parent
                    }
                    parent = parent.$parent
                }
                return component
            },
            refresh() {
                var me = this
                me.setImg = 'refresh'
                me.$nextTick(function () {
                    if (me.setImg == 'refresh') {
                        me.setImg = ''
                    } else {
                        me.setImg = 'refresh'
                    }
                })
            },
            /**
             * 자신이 그룹속으로 들어갔을 때의 이벤트
             * @param groupElement
             * @param element
             */
            onAddedToClass: function (groupElement, element, eventOffset) {
                var parentElement = groupElement.$parent
                if (groupElement.tagName) {
                    // Canvas로 나가는 경우
                } else {
                    element.$parent.value.groupElement = groupElement.$parent.value.elementView.id
                    
                    if(groupElement.label != element.$parent.value.name) {
                        if(element.text.includes('-')) {
                            var arr = (element.text.replace('- ', '')).split(': ');
                            var attrObject = {
                                "_type": "org.uengine.model.FieldDescriptor",
                                "name": arr[0],
                                "className": arr[1],
                                "label": element.text,
                            };
                            parentElement.value.fieldDescriptors.push(attrObject);

                            var delIdx = -1
                            element.$parent.value.fieldDescriptors.forEach(function (item, index) {
                                if (item.label == element.text) {
                                    delIdx = index
                                } 
                            })
                            if(delIdx != -1) {
                                element.$parent.value.fieldDescriptors.splice(delIdx, 1)
                            }
                        } else {
                            var arr = (element.text.replace('+ ', '')).split('(')
                            var arr2 = arr[1].split('): ')

                            var paramStr = arr2[0]
                            var newParams = []
                            if(params != "") {
                                var params = paramStr.split(', ')
                                if(params.length > 0) {
                                    params.forEach(function (item) {
                                        var param = item.split(': ')
                                        newParams.push({
                                            'type': param[1],
                                            'name': param[0]
                                        })
                                    })
                                }
                            }

                            var operationObj = {
                                "name": arr[0],
                                "class": parentElement.value.name,
                                "returnType": arr2[1],
                                "parameters": newParams,
                                "label": element.text,
                            };
                            parentElement.value.operations.push(operationObj)

                            var delIdx = -1
                            element.$parent.value.operations.forEach(function (item, index) {
                                if (item.label == element.text) {
                                    delIdx = index
                                } 
                            })
                            if(delIdx != -1) {
                                element.$parent.value.operations.splice(delIdx, 1)
                            }
                        }
                        this.refresh()
                    }
                }
            },
            /**
             * 자신이 그룹속으로 들어갔을 때의 이벤트
             * @param groupElement
             * @param element
             */
            onAddedToGroup: function (groupElement, element, eventOffset) {
                
                if (groupElement.tagName) {
                    // Canvas로 나가는 경우
                } else {
                    element.$parent.value.groupElement = groupElement.$parent.value.elementView.id
                }
            },
        }
    }
</script>


<style scoped lang="scss" rel="stylesheet/scss">
</style>
